<template>
  <div class="promotion-wrap">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_1.png">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_2.png" @click="toDetailPage">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_3.png">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_4.png" data-toid="sku" @click="goToTapById">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_5.png">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_6.png" id="sku">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_7.png">
    <img src="../../assets/image/Aions_Mar/Aions_Mar_8.png">

    <div class="applyPart">
      <div class="apply_button" @click="applyPartShow">
        <p>全部车型均可办理 填写手机咨询详情</p>
      </div>
      <div></div>
    </div>
    <div class="mask_layer" v-show="isApplyPartFlag" @click="applyPartShow"></div>
    <div class="applyPart_detail" v-show="isApplyPartFlag">
      <div class="item item-carType">
        <img src="../../assets/image/Aions_Mar/icon_car_blue.png">
        <select id="carType" v-model="carModel">
          <option>广汽新能源 Aion S 炫630</option>
          <option>广汽新能源 Aion S 魅630</option>
        </select>
        <img src="../../assets/image/Aions_Mar/icon_arrow_blue.png">
      </div>
      <div class="item item-mobile">
        <img src="../../assets/image/Aions_Mar/icon_phone_blue.png">
        <input type="tel" class="mobile" v-model="mobile" placeholder="输入手机号" maxlength="11" @focus="focusBorderColor"
               @blur="blurBorderColor"/>
      </div>
      <div class="item item-check">
        <img src="../../assets/image/Aions_Mar/icon_shield.png">
        <input type="number" class="verification_code" v-model="vCode" placeholder="输入验证码" maxlength="6"
               @input="vCodeMaxLength" @focus="focusBorderColor" @blur="blurBorderColor"/>
        <button class="getVcode" @click="getCode" ref="code" v-html="vCodeStr"></button>
      </div>
      <button class="submit" @click="submit">提交</button>
    </div>
  </div>
</template>

<script>
  import constants from '../../utils/constants'
  import common from '../../utils/common'
  import qs from 'qs'

  export default {
    name: "Aions_Mar",
    data() {
      return {
        leadsChannel: null,
        sourceType: null,
        isApplyPartFlag: false,
        carModel: '广汽新能源 Aion S 炫630',
        mobile: null,
        vCode: null,
        vCodeStr: '获取验证码',
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      const that = this
      that.$nextTick(function () {
        /* 记录促销页面打开时间 */
        that.$axios.post('/marketing/initPromotionLeadsChannelAionSMar', {}).then(function (res) {
          that.leadsChannel = res.data.data.leadsChannel,
            that.sourceType = res.data.data.sourceType,
            that.$axios.post('/marketing/initInfoInsert', qs.stringify({'leadsChannel': that.leadsChannel})).then(function (res) {
              return
            }).catch(function (error) {
              return
            })
        }).catch(function (error) {
          return
        })
        common.wxShare(that, constants.AIONS_SHAREINFO)
      });
    },
    methods: {
      /* 去详情页 */
      toDetailPage() {
        const router = this.$router;
        router.push({
          path: '/aions_mar_detail',
          query: {
            leadsChannel: this.leadsChannel,
            sourceType: this.sourceType,
            shareObj: this.AIONS_SHAREINFO,
            type: true
          }
        })
      },

      // 输入框获取或失去焦点时 底部边框颜色变化
      focusBorderColor(e) {
        e.currentTarget.parentNode.style.border = '0.02rem solid #268fff'
      },

      // 输入框获取或失去焦点时 底部边框颜色变化
      blurBorderColor(e) {
        e.currentTarget.parentNode.style.border = '0.02rem solid #cccccc'
        common.blurPageScroll()
      },

      // vue input type 为number时用maxlength无效
      //  此方法限制验证码输入位数
      vCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
      },

      // 模拟a标签锚点
      goToTapById(e) {
        common.tapToTop(e.target.dataset.toid)
      },

      // 弹出或隐藏手机验证弹窗
      applyPartShow() {
        this.isApplyPartFlag = !this.isApplyPartFlag
      },

      // 获取验证码
      getCode(e) {
        const vm = this
        common.getVCodeMarketing(vm, e)
      },

      // 提交信息
      submit() {
        const that = this
        if(common.trimAll(that.mobile) == null){
          common.tipToast("请输入手机号码")
          return
        }
        if(!common.checkMobile(that.mobile)){
          common.tipToast("手机号码格式不正确")
          return
        }
        if(common.isEmpty(common.trimAll(that.vCode))){
          common.tipToast("请输入手机号验证码")
          return
        }
        that.$axios.post('/marketing/promotionCreateOrder', qs.stringify({
          'code': that.vCode,
          'mobile': that.mobile,
          'carModel': that.carModel,
          'leadsChannel': that.leadsChannel,
          'sourceType': that.sourceType
        })).then(function (res) {
          clearInterval(common.VCodeObj.timer); // 清除js定时器
          that.carModel = '广汽新能源 Aion S 炫630'
          that.mobile = null
          that.vCode = null
          that.vCodeStr = '获取验证码',
          common.VCodeObj.timeCount = 60
          common.VCodeObj.timer = null
          that.$refs.code.disabled = false
          that.applyPartShow()
          common.tipToast("信息提交成功")
          return
        }).catch(function (error) {
          that.vCode = null
          common.tipToast(error.data.msg)
          return
        })
      }
    }
  }
</script>

<style scoped>
  .longMsgStyle {
    margin: 0 auto;
    width: 60%;
    left: 0 !important;
    right: 0 !important;
    transform: translate(-0%, -50%) !important;
  }

  .promotion-wrap {
    margin: 0 auto;
    max-width: 7.50rem;
    min-width: 3.20rem;
    padding-bottom: 1.16rem;
    position: relative;
    font-size: 0;
    width: 100%;
    text-align: center;
    background-color: #061432;
  }

  .promotion-wrap > img {
    width: 100%;
  }

  .applyPart {
    border-radius: 0.05rem 0.05rem 0 0;
    margin: 0 auto;
    width: 7.50rem;
    padding-top: 0.17rem;
    padding-bottom: 0.5rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.45);
    opacity: 1;
  }

  .applyPart .apply_button {
    position: relative;
    margin: 0 auto;
    width: 6.84rem;
    height: 0.88rem;
    background-image: linear-gradient(-138deg, #A68A4A 0%, #95653B 100%);
    background-blend-mode: normal,
    normal;
  }

  .applyPart .apply_button p {
    width: 100%;
    line-height: 0.88rem;
    font-size: 0.24rem;
    letter-spacing: 0;
    color: #fff;
  }
  .mask_layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #222 !important;
    opacity: .3;
    z-index: 9;
  }

  .applyPart_detail {
    border-radius: 0.05rem 0.05rem 0 0;
    margin: 0 auto;
    width: 7.5rem;
    padding-top: 0.36rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    font-size: 0;
    text-align: center;
    background-color: #fff;
    z-index: 10;
  }

  .applyPart_detail .item {
    position: relative;
    border: 0.01rem solid #ccc;
    border-radius: 0.06rem;
    margin: 0 auto;
    width: 6.98rem;
    height: 0.92rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

  .applyPart_detail .item-mobile img {
    position: absolute;
    left: 0.32rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 0.27rem;
    height: 0.38rem;
    z-index: 999;
  }

  .applyPart_detail .item-carType > img:first-child {
    margin: auto 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0.29rem;
    width: 0.32rem;
    height: 0.26rem;
  }

  .applyPart_detail .item-carType > img:last-child {
    position: absolute;
    right: 0;
    top: 43%;
    margin-right: 0.20rem;
    width: 0.17rem;
    height: 0.10rem;
  }

  .item-carType > select {
    display: block;
    padding-left: 0.84rem;
    width: 100%;
    height: 0.92rem;
    font-size: 0.26rem;
    background-color: #fff;
    color: #222;
    border-width: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: 0;
  }

  .applyPart_detail .item-check img {
    position: absolute;
    left: 0.31rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 0.30rem;
    height: 0.36rem;
    z-index: 999;
  }

  .applyPart_detail .item-carType {
    margin-bottom: 0.26rem;
  }
  .applyPart_detail .item-check {
    margin-top: 0.26rem;
  }

  .applyPart_detail input {
    padding-left: 0.84rem;
    width: 100%;
    height: 0.84rem;
    line-height: 0.32rem;
    font-size: 0.26rem;
    outline: none;
    border-width: 0;
  }

  .applyPart_detail .getVcode {
    padding: 0;
    margin: auto 0;
    position: absolute;
    right: 0.20rem;
    top: 0;
    bottom: 0;
    height: 0.48rem;
    font-size: 0.26rem;
    letter-spacing: 0px;
    color: #268fff;
    background-color: #fff;
    outline: none;
    border-width: 0;
    text-align: right;
    z-index: 999;
  }

  .applyPart_detail .submit {
    margin-top: 0.40rem;
    margin-bottom: 0.49rem;
    width: 6.98rem;
    height: 0.92rem;
    font-size: 0.32rem;
    color: #fff;
    background-image: linear-gradient(-138deg, #A68A4A 0%, #95653B 100%);
    background-blend-mode: normal,
    normal;
    border-radius: 6px;
    outline: none;
    border-width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Promotion/Aions_Mar.vue